import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import React, { useState, useRef } from 'react';
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import useAuthAxios from "../../../useAuthAxios";
import LoadingDialog from '../../Loading';
import {
    NomalButton,
} from '../../css/CSS.js';

export default function UploadButtons(props) {
    const { control } = useForm({
        defaultValues: {
            attachFileData: "",
            attachFileName: "",
        },
    });


    const authAxios = useAuthAxios();
    const [files, setFiles] = useState();
    const [uploadDone, setUploadDone] = useState(false);
    const [activePost, setactivePost] = useState(false);
    const headers = { "Authorization": "Bearer " + localStorage.getItem("Auth"), 'Content-Type': 'multipart/form-data' };
    const navigate = useNavigate();
    const [processing, setProcessing] = useState(false);
    const inputPostFileRef = useRef(null);
    const [fileCount, setFileCount] = useState(0);
    const [inputKey, setInputKey] = useState(0);

    const handleFileInputChange = (e) => {

        if (!e.target.files) {
            return;
        }


        let fileCount = 0
        props?.attachedData.map((item, index) => (
            (item.fileShubetsu === props.fileTypeId) ?
                fileCount++
                : null
        ))

        if (fileCount + e.target.files.length > props.maxFileNum) {
            alert('添付ファイルは' + props.maxFileNum + 'ファイルまで添付可能です。')
            setInputKey((prevKey) => prevKey + 1)
            return;
        }
        const attachFileExts = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'heic']
        for (let i = 0; i < e.target.files.length; i++) {
            if (!attachFileExts.includes(e.target.files[i].name.split('.').pop().toLowerCase())) {
                alert("下記のいずれかのファイルを選択して下さい。\n" + attachFileExts)
                setInputKey((prevKey) => prevKey + 1)
                return;
            }
            let fileNameLengthCounter = 0;
            for (let j = 0; j < e.target.files[i].name.length; j++) {
                if (e.target.files[i].name[j].match(/^[^ -~｡-ﾟ]/)) {
                    fileNameLengthCounter += 2
                } else {
                    fileNameLengthCounter += 1
                }
                if (fileNameLengthCounter > 60) {
                    alert("ファイル名は半角60文字、全角30文字以内に指定してください。\n\n超過したファイル名：" + e.target.files[i].name)
                    setInputKey((prevKey) => prevKey + 1)
                    return
                }
            }
        }

        setFileCount(e.target.files.length);
        setFiles(e.target.files);
        setInputKey((prevKey) => prevKey + 1)
        setactivePost(true);
    };

    const onSubmit = () => {
        if (files != null) {
            setactivePost(true);
        }
    };

    const PostFileUpload = () => {
        inputPostFileRef.current.click();
    }

    React.useEffect(() => {
        if (processing === true) { return }

        if (activePost === true) {
            setProcessing(true);
            //let uploadCount = 0;
            //for (let i = 0; i < fileCount; i++) {
            //    const fileObject = files[i];
            //    const body = new FormData();
            //    body.append("fileName", fileObject.name);
            //    body.append("file", fileObject);
            //    authAxios
            //        .post('api/visitReport'
            //            + "/" + props.keyData.kojiCD
            //            + "/" + props.keyData.rptShubetsu
            //            + "/" + props.keyData.rptSeq
            //            + "/" + props.fileTypeId
            //            , body
            //            , { headers })
            //        .then(response => {
            //            if (response.status === 200) {
            //                uploadCount++
            //                if (uploadCount === fileCount) {
            //                    setUploadDone(true)
            //                    props?.setAttachedFileStatus(true)
            //                    setactivePost(false);
            //                }
            //            }
            //        }).catch((error) => {
            //            if (error.response.status === 401) {
            //                alert("認証情報が正しくありません。");
            //                navigate("/");
            //            } else {
            //                alert("添付ファイル登録に失敗しました。");
            //                setactivePost(false);
            //            }
            //            setProcessing(false);
            //        });
            //}
            //setactivePost(false);
            //setProcessing(false);
            async function postLoopFunction() {
                for (let i = 0; i < fileCount; i++) {
                    const fileObject = files[i];
                    const body = new FormData();
                    body.append("fileName", fileObject.name);
                    body.append("file", fileObject);
                    await authAxios
                        .post('api/visitReport'
                            + "/" + props.keyData.kojiCD
                            + "/" + props.keyData.rptShubetsu
                            + "/" + props.keyData.rptSeq
                            + "/" + props.fileTypeId
                            , body
                            , { headers })
                        .then(response => {
                            if (response.status !== 200) {
                                alert("添付ファイル登録に失敗しました。");
                                setactivePost(false);
                            }
                        }).catch((error) => {
                            if (error.response.status === 401) {
                                alert("認証情報が正しくありません。");
                                navigate("/");
                            } else {
                                alert("添付ファイル登録に失敗しました。");
                                setactivePost(false);
                            }
                            setProcessing(false);
                        });
                }
            }
            async function postConcurrently() {
                await postLoopFunction()
                setUploadDone(true)
                props?.setAttachedFileStatus(true)
                setactivePost(false);
                setProcessing(false);
            }
            postConcurrently()
        }
    }, [activePost]);


    React.useEffect(() => {
        if (!uploadDone) { return }
        props?.setAttachedFileStatus(true)
    }, [uploadDone]);



    return (
        <label htmlFor="contained-button-file">
            <LoadingDialog load={processing} />
            <form onSubmit={onSubmit} >
                <Controller
                    control={control}
                    name="attachmentFile"
                    render={({ field }) => (
                        <FileUploadButton
                            {...field}
                            key= {inputKey}
                            className="primary"
                            name="inspectionFiles"
                            ref={inputPostFileRef}
                            onChange={handleFileInputChange}
                            onClick={PostFileUpload}
                            sx={{ boxShadow: 0, fontSize: 45 }}
                            disabled={props?.keyData?.status === 4 || !props?.keyData?.canEdit ? true : false}
                        />
                    )}
                />
            </form>
        </label>
    );
}


export const FileUploadButton = React.forwardRef((props, ref) => {
    return (
        <label htmlFor={`upload-button-${props.name}`}>
            <input
                accept=".pdf,.jpg,.jpeg,.png,.gif,.bmp,.svg,.webp,.heic"
                id={`upload-button-${props.name}`}
                name={props.name}
                multiple
                key={props.inputKey}
                type="file"
                ref={ref}
                onChange={props.onChange}
                disabled={props?.disabled}
                hidden
            />
            <NomalButton
                variant="contained"
                size="large"
                {...props}
                sx={{ ml: 2, mr: 2, pt: 1.5, pb: 1.5, pl: 4, pr: 4, fontSize: '18px' }}
                disabled={props?.disabled}
                onClick={props.onClick}
            >
                {props.children}
                <AddPhotoAlternateIcon sx={{ mr: 2, fontSize: '2rem' }} />
                ファイル選択
            </NomalButton>
        </label>
    );
});

